"use strict";

/**
 * @param {Shipment} shipment
 * @param {*} options
 */
function parseTags() {
  console.log('todo: parse ship station tags');
  return [];
}

module.exports = parseTags;